module.exports = __webpack_public_path__ + "static/media/menu.c619022a.svg";